import { render, staticRenderFns } from "./AddNovelUpdate.vue?vue&type=template&id=5ba3b1dd"
import script from "./AddNovelUpdate.vue?vue&type=script&lang=js"
export * from "./AddNovelUpdate.vue?vue&type=script&lang=js"
import style0 from "./AddNovelUpdate.vue?vue&type=style&index=0&id=5ba3b1dd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports